import React from 'react';
import { useParams } from 'react-router-dom';
import { ProFormDatePicker, ProFormTextArea } from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import ProForm from '../../../layout/ProForm';
import { WIDTH_2_COL } from 'constants/form';

const TerminationForm = ({
  onFinish,
  withCustomDate,
  initialValues,
  projectFrozen,
  isTerminated,
}) => {
  const { projectId } = useParams();
  return (
    <ProForm
      onFinish={onFinish}
      previousLevel={`/projects/${projectId}/profile`}
      initialValues={initialValues}
      requiredMark={false}
      disabled={projectFrozen || isTerminated}
    >
      <ProFormDatePicker
        label="Termination Date"
        name="date"
        width="xl"
        disabled={!withCustomDate || projectFrozen || isTerminated}
        rules={
          withCustomDate
            ? [
                {
                  required: true,
                  message: 'Please enter termination date!',
                },
              ]
            : []
        }
      />

      <ProFormTextArea
        width={WIDTH_2_COL}
        name="reason"
        label="Reason"
        placeholder="reason"
        disabled={projectFrozen || isTerminated}
        rules={[
          {
            required: true,
            message: 'Please enter reason!',
          },
        ]}
      />
    </ProForm>
  );
};

TerminationForm.defaultProps = {
  withCustomDate: false,
  projectFrozen: false,
  isTerminated: false,
};

TerminationForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  withCustomDate: PropTypes.bool.isRequired,
  initialValues: PropTypes.object.isRequired,
  projectFrozen: PropTypes.bool.isRequired,
  isTerminated: PropTypes.bool.isRequired,
};

export default TerminationForm;
